import { IInputWidget, WidgetType } from '@framework/engine';
import type { SelectOption } from '@framework/form';

export const WidgetMultiPreferenceType =
  'multiPreference' as WidgetType.MultiPreference;

export interface IMultiPreferenceWidget extends IInputWidget {
  type: WidgetType.MultiPreference;
  cascade?: IWidgetCascadeConfig;
}

export interface IWidgetCascadeCombination {
  values: string[];
}

export interface IWidgetCascadeField {
  label: string;
  index: number;
}

export interface IWidgetCascadeConfig {
  fields: IWidgetCascadeField[];
  combinations: IWidgetCascadeCombination[];
}

/**
 * Configurazione del singolo campo (field) nel contesto della richiesta (valori)
 * corrente.
 */
export interface IWidgetCascadeRequestField {
  field: IWidgetCascadeField;
  value: any;
  /** Indica se il campo deve apparire come disabilitato o meno nel form */
  disabled: boolean;
  availableCombinations: IWidgetCascadeCombination[];
  options: SelectOption[];
}
